import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, Button, Select, MenuItem, InputLabel, FormControl, Snackbar, Alert, Pagination } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import DeletedCliches360 from './DeletedCliches360'; // Certifica-te que o caminho está correto


const TIPO_TRABALHO_CHOICES = [
    { value: 'serigrafia branco', label: 'Serigrafia Branco' },
    { value: 'serigrafia dourado', label: 'Serigrafia Dourado' },
    { value: 'serigrafia prata', label: 'Serigrafia Prata' },
    { value: 'serigrafia cores', label: 'Serigrafia Cores' },
];

const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local


const TAMANHO_CHOICES = [
    '54*16*44', '54*16*49', '42*16*34', '42*16*49', '40*11*32', 
    '35*16*44', '31*20*32', '30*16*31', '32*11*28', '32*11*32',
    '32*11*42', '27*16*31', '28*11*32', '26*11*22', '26*11*32',
    '24*11*32', '22*10*27', '18*8*24', '18*8*39'
];

const Cliches360imprimir = () => {
    const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
    const [cliches, setCliches] = useState([]);
    const [selectedCliche, setSelectedCliche] = useState(null);
    const [newClicheModalOpen, setNewClicheModalOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [tipoTrabalhoFilter, setTipoTrabalhoFilter] = useState('');
    const [planoFilter, setPlanoFilter] = useState('');
    const [newCliche, setNewCliche] = useState({
        nome_trabalho: '',
        plano: '',
        tipo_trabalho: '',
        tamanho: '',
        foto: null
    });
    const [imageSrc, setImageSrc] = useState(null); // Para armazenar a imagem capturada
    const [stream, setStream] = useState(null); // Para controlar o stream da câmera
    const user = JSON.parse(localStorage.getItem('user'));
    const isAdmin = user && user.seccao === 'Admin';
    const [currentPage, setCurrentPage] = useState(1); // Estado para controlar a página atual
    const itemsPerPage = 50; // Limita a 50 entradas por página
    const [deletedClichesModalOpen, setDeletedClichesModalOpen] = useState(false);
    axios.defaults.withCredentials = true; // Habilita o envio de cookies de sessão
    
    const token = localStorage.getItem('token');  // Acede diretamente ao token do localStorage

    useEffect(() => {
        
            fetchCliches360Imprimir();  // Só faz a requisição se o token existir
        
    }, []);

    const fetchCliches360Imprimir = async () => {
        try {
            const response = await axios.get(`${apiBaseURL}/api/cliches360imprimir/`, {
                headers: {
                    Authorization: `Bearer ${token}`,  // Inclui o token no cabeçalho da requisição
                },
            });
            setCliches(response.data);  // Atualiza o estado com os clichês
        } catch (error) {
            console.error('Erro ao buscar clichês 360imprimir:', error);
            setAlert({ open: true, message: 'Erro ao buscar clichês.', severity: 'error' });
        }
    };

    

    const handleOpenModal = (cliche) => {
        setSelectedCliche(cliche);
    };

    const handleCloseModal = () => {
        setSelectedCliche(null);
    };

    const handleOpenNewClicheModal = () => {
        setNewClicheModalOpen(true);
    };

    const handleCloseNewClicheModal = () => {
        setNewClicheModalOpen(false);
    };

    const handleCreateCliche = async () => {
        try {
            // Requisição para buscar o maior número de clichê do tipo_trabalho selecionado
            const tipoTrabalhoFormatado = newCliche.tipo_trabalho.replace(/ /g, '_');
            const responseNumeroCliche = await axios.get(`${apiBaseURL}/api/cliches360imprimir/max-numero/${tipoTrabalhoFormatado}/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
    
            // Garantir que o valor retornado seja tratado corretamente
            const maxNumeroCliche = responseNumeroCliche.data.max_numero || 0; // Caso seja null, define como 0
            const novoNumeroCliche = parseInt(maxNumeroCliche, 10) + 1; // Incrementa de forma segura
    
            const formData = new FormData();
            formData.append('nome_trabalho', newCliche.nome_trabalho);
            formData.append('plano', newCliche.plano);
            formData.append('tamanho', newCliche.tamanho);
            formData.append('tipo_trabalho', newCliche.tipo_trabalho);
            formData.append('numero_cliche', novoNumeroCliche.toString()); // Garantir que o número é convertido para string
    
            // Verifica se há uma imagem capturada pela câmera ou upload de arquivo
            if (imageSrc) {
                const response = await fetch(imageSrc);
                const blob = await response.blob();
                formData.append('foto', blob, 'captured-image.png'); // Adiciona a imagem capturada
            } else if (newCliche.foto) {
                formData.append('foto', newCliche.foto, newCliche.foto.name);
              }
    
            // Adiciona o utilizador atual que criou o clichê
            const user = JSON.parse(localStorage.getItem('user'));
            formData.append('criado_por', user.id); // Associa o clichê ao criador (user.id)
    
            // Envia a requisição POST para a API
            const response = await axios.post(`${apiBaseURL}/api/cliches360imprimir/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // Importante para envio de arquivos
                    Authorization: `Bearer ${localStorage.getItem('token')}`, // Token JWT
                },
            });
    
            // Lógica após o sucesso do envio
            console.log('Clichê criado com sucesso:', response.data);
            setAlert({ open: true, message: 'Clichê criado com sucesso!', severity: 'success' });
    
            // Fechar modal após salvar
            handleCloseNewClicheModal();
    
            // Atualiza a lista de clichês
            fetchCliches360Imprimir();
        } catch (error) {
            console.error('Erro ao criar clichê:', error);
            setAlert({ open: true, message: 'Erro ao criar clichê.', severity: 'error' });
        }
    };
    

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        console.log('Arquivo selecionado:', file);
        setNewCliche({ ...newCliche, foto: file });
      };

    const openCamera = async () => {
        try {
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                console.error('O navegador não suporta o acesso à câmera.');
                return;
            }

            const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true });
            setStream(mediaStream);

            const videoElement = document.createElement('video');
            videoElement.srcObject = mediaStream;
            videoElement.play();
            document.getElementById('video-container').appendChild(videoElement);
        } catch (err) {
            console.error('Erro ao acessar a câmera:', err);
        }
    };

    const takePicture = () => {
        const videoElement = document.querySelector('video');
        const canvas = document.createElement('canvas');
        canvas.width = videoElement.videoWidth;
        canvas.height = videoElement.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
        const imageDataUrl = canvas.toDataURL('image/png');
        setImageSrc(imageDataUrl);
        closeCamera();
    };

    const closeCamera = () => {
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
            setStream(null);
        }
        document.querySelector('video').remove();
    };

    const handleDeleteCliche = async (cliche) => {
        try {
            const formData = new FormData();
            
            // Adiciona os campos necessários ao FormData
            formData.append('nome_trabalho', cliche.nome_trabalho);
            formData.append('plano', cliche.plano);
            formData.append('tamanho', cliche.tamanho);
            formData.append('numero_cliche', cliche.numero_cliche);
            formData.append('tipo_trabalho', cliche.tipo_trabalho);
    
            // Passa apenas a URL da foto
            if (cliche.foto) {
                formData.append('foto_url', cliche.foto);
            }
    
            // Adiciona o utilizador que eliminou o clichê
            const user = JSON.parse(localStorage.getItem('user'));
            formData.append('eliminado_por', user.id); // Adiciona o ID do utilizador que eliminou
    
            // Faz a requisição para mover o clichê para a base de dados de eliminados
            await axios.post(`${apiBaseURL}/api/cliches360imprimireliminados/`, formData, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'multipart/form-data', // Para lidar com imagens
                },
            });
    
            // Agora, apaga a entrada original da base de dados "Cliche360Imprimir"
            await axios.delete(`${apiBaseURL}/api/cliches360imprimir/${cliche.id}/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
    
            // Mostra um alerta de sucesso
            setAlert({ open: true, message: 'Clichê movido para eliminados com sucesso e removido da lista original.', severity: 'success' });
    
            // Atualiza a lista de clichês
            fetchCliches360Imprimir();
        } catch (error) {
            console.error('Erro ao mover clichê para eliminados:', error);
            setAlert({ open: true, message: 'Erro ao mover clichê para eliminados.', severity: 'error' });
        }
    };

    const filteredCliches = cliches.filter(cliche => {
        const matchesSearchTerm =
            cliche.nome_trabalho.toLowerCase().includes(searchTerm.toLowerCase()) ||
            cliche.numero_cliche.toLowerCase().includes(searchTerm.toLowerCase());
        
        const matchesTipoTrabalho = !tipoTrabalhoFilter || cliche.tipo_trabalho === tipoTrabalhoFilter;
        
        const matchesPlanoFilter = cliche.plano.toLowerCase().includes(planoFilter.toLowerCase());
    
        // Retorna verdadeiro apenas se todas as condições forem atendidas
        return matchesSearchTerm && matchesTipoTrabalho && matchesPlanoFilter;
    });

    // Determina os itens da página atual
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredCliches.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (event, value) => {
        setCurrentPage(value); // Atualiza a página atual
    };



    return (
        <Box sx={{ mt: 4 }}>
            <Typography variant="h5" gutterBottom>Clichês 360imprimir</Typography>

            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
                {isAdmin && (
                    <>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setDeletedClichesModalOpen(true)}  // Abre a modal ao clicar no botão
                        startIcon={<DeleteIcon />}
                    >
                        Ver Clichês Eliminados
                    </Button>
        
                    <DeletedCliches360 
                        open={deletedClichesModalOpen} 
                        onClose={() => setDeletedClichesModalOpen(false)} // Fecha a modal
                    />
                </>
                
                )}

                <IconButton color="primary" onClick={handleOpenNewClicheModal}>
                    Adicionar Clichê<AddIcon />
                </IconButton>
            </Box>

            <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                <TextField
                    label="Pesquisar Nome ou Número Clichê"
                    variant="outlined"
                    fullWidth
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <FormControl fullWidth>
                    <InputLabel>Tipo de Trabalho</InputLabel>
                    <Select
                        value={tipoTrabalhoFilter}
                        onChange={(e) => setTipoTrabalhoFilter(e.target.value)}
                    >
                        <MenuItem value="">Todos</MenuItem>
                        {TIPO_TRABALHO_CHOICES.map(choice => (
                            <MenuItem key={choice.value} value={choice.value}>
                                {choice.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    label="Pesquisar Plano"
                    variant="outlined"
                    fullWidth
                    value={planoFilter}
                    onChange={(e) => setPlanoFilter(e.target.value)}
                />
            </Box>

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nome do Trabalho</TableCell>
                            <TableCell>Número do Clichê</TableCell>
                            <TableCell>Tamanho</TableCell>
                            <TableCell>Tipo de Trabalho</TableCell>
                            <TableCell>Plano</TableCell>
                            <TableCell>Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {currentItems.map((cliche) => (
                            <TableRow 
                            key={cliche.id} 
                            onClick={() => handleOpenModal(cliche)}
                            sx={{
                                cursor: 'pointer',
                                transition: 'box-shadow 0.3s ease-in-out', // Suaviza a transição
                                '&:hover': {
                                    backgroundColor: '#9ac6f5',
                                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)', // Adiciona a borda em "hover"
                                },
                            }}
                        >
                                <TableCell>{cliche.nome_trabalho}</TableCell>
                                <TableCell>{cliche.numero_cliche}</TableCell>
                                <TableCell>{cliche.tamanho}</TableCell>
                                <TableCell>{cliche.tipo_trabalho}</TableCell>
                                <TableCell>{cliche.plano}</TableCell>
                                <TableCell>
    <IconButton color="secondary" onClick={() => handleDeleteCliche(cliche)}>
        <DeleteIcon />
    </IconButton>
    <Button variant="outlined" color="primary" onClick={() => handleOpenModal(cliche)}>
        Visualizar
    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Paginação */}
            <Pagination
                count={Math.ceil(filteredCliches.length / itemsPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}
            />

            {selectedCliche && (
    <Modal open={Boolean(selectedCliche)} onClose={handleCloseModal}>
        <Box 
        sx={{ 
            p: 4, 
            backgroundColor: 'white', 
            width: '90%', // A modal ocupará 90% da largura da tela
            maxWidth: 500, // Máximo de 500px
            margin: 'auto', 
            mt: { xs: '20%', sm: '10%' }, // Margem superior de 20% em telas pequenas e 10% em maiores
            borderRadius: 2, // Bordas arredondadas para um visual mais moderno
            maxHeight: '80vh', // Limite de altura da modal (80% da altura da viewport)
            overflowY: 'auto' // Adiciona rolagem quando o conteúdo excede a altura
        }}
    >
        <Typography variant="h4" gutterBottom color="primary">
                {selectedCliche.nome_trabalho}
            </Typography>
            <Typography variant="body1">Número do Clichê: {selectedCliche.numero_cliche}</Typography>
            <Typography variant="body1">Tamanho: {selectedCliche.tamanho}</Typography>
            <Typography variant="body1">Tipo de Trabalho: {selectedCliche.tipo_trabalho}</Typography>
            <Typography variant="body1">Plano: {selectedCliche.plano}</Typography>

            {selectedCliche.foto ? (
                <Box sx={{ my: 2, borderRadius: 2, overflow: 'hidden' }}>
                    <img src={selectedCliche.foto} alt={selectedCliche.nome_trabalho} style={{ width: '100%', borderRadius: '8px' }} />
                </Box>
            ) : (
                <Typography sx={{ my: 2, color: 'text.secondary', fontStyle: 'italic' }}>
                    Imagem não disponível
                </Typography>
            )}

            <Button onClick={handleCloseModal} variant="contained" color="primary" sx={{ mt: 2 }}>
                Fechar
            </Button>
        </Box>
    </Modal>
)}

<Modal open={newClicheModalOpen} onClose={handleCloseNewClicheModal}>
    <Box 
        sx={{
            p: 4,
            backgroundColor: 'white',
            width: '90%',
            maxWidth: 500,
            margin: 'auto',
            mt: '10%',
            borderRadius: 2,
            maxHeight: '80vh',
            overflowY: 'auto',
        }}
    >
        <Typography variant="h5" gutterBottom>Adicionar Novo Clichê</Typography>

        <TextField
            label="Nome do Trabalho"
            fullWidth
            margin="normal"
            value={newCliche.nome_trabalho}
            onChange={(e) => setNewCliche({ ...newCliche, nome_trabalho: e.target.value })}
        />

        <TextField
            label="Número do Plano"
            fullWidth
            margin="normal"
            value={newCliche.plano}
            onChange={(e) => setNewCliche({ ...newCliche, plano: e.target.value })}
        />

        <FormControl fullWidth margin="normal">
            <InputLabel>Tipo de Trabalho</InputLabel>
            <Select
                value={newCliche.tipo_trabalho}
                onChange={(e) => setNewCliche({ ...newCliche, tipo_trabalho: e.target.value })}
            >
                {TIPO_TRABALHO_CHOICES.map(choice => (
                    <MenuItem key={choice.value} value={choice.value}>{choice.label}</MenuItem>
                ))}
            </Select>
        </FormControl>

        <FormControl fullWidth margin="normal">
            <InputLabel>Tamanho</InputLabel>
            <Select
                value={newCliche.tamanho}
                onChange={(e) => setNewCliche({ ...newCliche, tamanho: e.target.value })}
            >
                {TAMANHO_CHOICES.map(choice => (
                    <MenuItem key={choice} value={choice}>{choice}</MenuItem>
                ))}
            </Select>
        </FormControl>

        <Box>
            <Button variant="contained" onClick={openCamera} fullWidth sx={{ mt: 2 }}>
                Abrir Câmera
            </Button>

            <Box id="video-container" sx={{ mt: 2 }} />

            {imageSrc && <img src={imageSrc} alt="Captured" style={{ width: '100%' }} />}

            {stream && (
                <Button variant="contained" color="primary" onClick={takePicture} fullWidth sx={{ mt: 2 }}>
                    Tirar Foto
                </Button>
            )}

            {stream && (
                <Button variant="contained" color="secondary" onClick={closeCamera} fullWidth sx={{ mt: 2 }}>
                    Fechar Câmera
                </Button>
            )}
        </Box>

        <Button variant="contained" component="label" fullWidth sx={{ mt: 2 }}>
            Adicionar Foto
            <input type="file" hidden accept="image/*;capture=camera" onChange={handleFileChange} />
        </Button>

        <Box mt={2} display="flex" justifyContent="space-between">
            <Button variant="contained" color="primary" onClick={handleCreateCliche}>Confirmar</Button>
            <Button variant="outlined" color="secondary" onClick={handleCloseNewClicheModal}>Cancelar</Button>
        </Box>
    </Box>
</Modal>


            <Snackbar
                open={alert.open}
                autoHideDuration={6000}
                onClose={() => setAlert({ ...alert, open: false })}
            >
                <Alert onClose={() => setAlert({ ...alert, open: false })} severity={alert.severity}>
                    {alert.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default Cliches360imprimir;
